// Copyright 1999-2018. Plesk International GmbH. All rights reserved.

const initRnameState = () => {
    const radios = [...document.querySelectorAll('input[name*=rname_type]')];

    const applyState = () => {
        radios.forEach(radio => {
            const input = document.getElementById(`soaRecord-rname_${radio.value}`);
            if (!input) {
                return;
            }

            const { classList } = input.parentElement;
            if (radio.checked) {
                classList.remove('hidden');
                input.removeAttribute('disabled');
            } else {
                classList.add('hidden');
                input.setAttribute('disabled', 'true');
            }
        });
    };

    radios.forEach(radio => radio.addEventListener('change', applyState));

    applyState();
};

export default () => {
    initRnameState();
};



// WEBPACK FOOTER //
// ./app/dns-zone/soa-record-rname.js